<div class="col-12 mx-auto mt-5" layout="row" layout-align="center center">

    <h2 class="ml-2">{{'menu_termsofuse' | translate}}</h2>
    <!--<a backButton class="close">&times;</a>-->
    <!--<div [innerHTML]="Terms"></div>-->
    <iframe [srcdoc]="Terms"></iframe>
  
</div>